import { byAsc } from '@utils/collections'
import calculateDistance from './calculateDistance'

const qualitiesCompared = [
  'computingScore',
  'graphicsScore',
  'memoryScore',
  'storageScore',
]

const distanceMultidimensional = calculateDistance(qualitiesCompared)

export default (selectedLaptop, laptops) => laptops
  .map(laptop => ({
    ...laptop,
    distance: distanceMultidimensional(selectedLaptop, laptop),
  }))
  .sort(byAsc('distance'))
